// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"SvgPieChartListView_svgContainer__3VLRK"};